/* builder.js — page script for build.html and the matching Shopify template.
   Loads after app.js, which defines CONFIG and the shared engine. */
if (typeof CONFIG === 'undefined' || typeof buildKeychain === 'undefined')
  throw new Error('app.js must load BEFORE builder.js — check the script order in the layout');

/* ══════════════ builder state ══════════════ */
// The cord is deliberately absent: we choose it from whatever paracord suits
// the finished piece, so it is neither shown here nor carried in the design.
const ZONES = [
  {k:'letter', label:'Letter'}, {k:'cap', label:'Keycap'}, {k:'base', label:'Base'}
];
// `state` is the print spec and nothing else — it is what lands in _build.
// Opens in Lagoon — the combo most ordered for boys' names, and the one Zayeds
// mostly get — so the preview and the Most loved row agree from the first glance.
const state = { name:'ZAYED', letter:'#FFFFFF', cap:'#4A9BE8', base:'#B3DCD6',
                finish:'Raised' };
let zone = 'letter', qty = 1, view = 'flat';   // view is a camera angle, not part of the design

const svg = $('pv');
const build = () => buildKeychain(svg, state, view);
// A share link renders before Fredoka finishes loading, and some webviews
// never repaint SVG text after the swap — the keycaps stayed in the fallback
// font. One rebuild once the fonts settle makes the preview honest everywhere.
if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
const paint = () => paintKeychain(svg, state);

const nCaps   = () => nCapsOf(state);
const priceOf = () => priceOfDesign(state);          // the keychain variant alone
const totalOf = () => { const p = priceOf(); return p == null ? null : p + charmCost(state); };

function renderZones(){
  $('zones').innerHTML = ZONES.map(z =>
    `<button class="zone" data-z="${z.k}" aria-pressed="${zone===z.k}">
       <span style="background:${state[z.k]}"></span>${z.label}</button>`).join('');
}
function renderSwatches(){
  $('swatches').innerHTML = CONFIG.filaments.map(c => {
    const out = !inStock(c);
    return `<button class="sw${out ? ' out' : ''}" data-h="${c.h}"
       aria-pressed="${state[zone].toLowerCase() === c.h.toLowerCase()}"
       ${out ? 'disabled aria-disabled="true"' : ''}
       title="${c.n}${out ? ' — out of stock' : ''}"><i style="background:${c.h}"></i><span>${c.n}</span></button>`;
  }).join('');
}
/* The cord row: the classic cord and the special charm cord. The whole row
   hides when the charm cord is not on sale, so the theme can ship before the
   product exists and the note under the swatches still explains the cord. */
function renderCharms(){
  const row = $('charmRow'); if (!row) return;
  row.hidden = !charmOffered();
  if (row.hidden) return;
  // A small, honest stock count on the card once it gets low; the row hides
  // itself at zero (Shopify reports the variant unavailable).
  // Shopify's tracked count, worn as a sticker on the card's corner — but as a
  // word, never a number: "Limited" while there are more than a handful, "Few
  // left" at five or fewer. Straight from inventory, never a theme setting;
  // null (untracked) = no sticker. Shopify itself refuses to oversell.
  const left = charmStock();
  const tag = left == null ? '' : `<i class="stock${left <= 5 ? ' low' : ''}">${left <= 5 ? 'Few left' : 'Limited'}</i>`;
  $('charms').innerHTML = [{id:'', n:'Classic', sub:'matched by us', price:'Included', tag:'', ring:''},
    {id:CHARM.id, n:CHARM.n, sub:'matched by us', price:'+' + money(charmPrice()), tag,
     ring:'<i class="ring">&#128276; It jingles</i>'}]
    .map(c => `<button class="charm" data-c="${c.id}" aria-pressed="${(state.charm || '') === c.id}">
       ${c.tag}${cordCardSVG(!!c.id)}<b>${c.n}</b><small>${c.sub}</small><em>${c.price}</em>${c.ring}</button>`).join('');
}
let PRESETS = [];
function renderPresets(){
  // Only offer what we can print, so nothing needs to be shown greyed out.
  PRESETS = availablePresets();
  // Most-ordered first (see CONFIG.presets); the counts stay backstage.
  $('presets').innerHTML = PRESETS.map((p,i) =>
    `<button class="pre" data-p="${i}" title="${p.n}"><s>${PZONES
      .map(k => `<i style="background:${p[k]}"></i>`).join('')}</s>${p.n}</button>`).join('');
  markPreset();
  // Theme assets and templates can arrive in Shopify at different moments, so
  // never assume a template element is already there.
  if ($('presetRow')) $('presetRow').hidden = PRESETS.length === 0;
  updatePresetHint();
}
function renderPrice(){
  const p = priceOf();                       // null = no such variant in Shopify
  const cord = state.charm ? ' + special charm' : '';
  $('price').textContent = p == null ? 'Unavailable' : money(totalOf());
  $('perNote').textContent = p == null
    ? `A ${nCaps()}-keycap keychain is not set up in the shop yet.`
    : PAP ? `${nCaps()} keycaps${cord}`
          : `AED ${CONFIG.basePrice} base + AED ${CONFIG.perCap} × ${nCaps()} keycaps${cord}`;
  $('nLen').textContent = nCaps();
  $('add').disabled = !state.name.trim() || p == null;
}
function renderWarn(){
  const w = $('warn'), r = contrast(state.letter, state.cap);
  w.classList.toggle('on', r < CONFIG.contrastMin);
  if (r < CONFIG.contrastMin) w.innerHTML =
    `⚠️ <b>${nameOf(state.letter,CONFIG.filaments)} on ${nameOf(state.cap,CONFIG.filaments)}</b>
     is too close to read once printed. Pick a letter colour with more contrast.`;
}
/* Light up the pill whose three colours are on screen, so the row and the
   preview visibly agree; hand-mix a colour and every pill goes quiet. */
function markPreset(){
  const same = (a, b) => String(a).toLowerCase() === String(b).toLowerCase();
  $('presets').querySelectorAll('[data-p]').forEach(b => {
    const p = PRESETS[b.dataset.p];
    b.setAttribute('aria-pressed', PZONES.every(k => same(p[k], state[k])));
  });
}
function renderAll(){
  renderZones(); renderSwatches(); markPreset(); renderCharms(); renderPrice(); renderWarn();
  setDealUnit(totalOf()); renderDeals(); renderUpsell();
  syncURL();
}

/* Design lives in the query string, so a design is shareable by pasting the link.
   Query, not hash — the hash belongs to the nav anchors. */
const isTest = new URLSearchParams(location.search).has('test');
function syncURL(){
  const p = new URLSearchParams({...state, q:qty});
  if (editing) p.set('edit', editing);     // survive a refresh mid-edit
  if (isTest) p.set('test','');            // keep the flag so a refresh re-runs the checks
  history.replaceState(null, '', '?' + p + location.hash);
}
function loadURL(){
  const p = new URLSearchParams(location.search);
  for (const k of DESIGN_KEYS)
    if (p.get(k)) state[k] = p.get(k);
  state.name = clean(state.name);
  state.finish = cleanFinish(state.finish);
  state.charm = cleanCharm(state.charm);
  if (!state.charm) delete state.charm;    // absent = the classic cord
  qty = Math.max(1, Math.min(99, +p.get('q') || 1));
}

/* ══════════════ events ══════════════ */
/* The funnel dedupe. pap_builder_view fires once at boot (below); pap_builder_start
   on the FIRST meaningful customization; pap_builder_ready the first time both
   halves are true: the customer has customized at least once AND the design
   passes the real purchasability gate — the same gate as the add button.
   Ready is a READINESS event, not proof the customer considers the design
   finished; this builder has no Done/Review action, and a pap_builder_completed
   must not exist until one does. Each fires once per page load: editing after
   readiness is the same session, not a second funnel. The add handler calls
   this first, so a customer who arrives on a shared link and buys untouched
   still walks the funnel in order. Zone selection and rotate are navigation,
   not customization — they do not start the funnel. */
const funnel = { started: false, ready: false };
function funnelStep(){
  if (!funnel.started) { funnel.started = true; track('pap_builder_start', {}); }
  if (!funnel.ready && !$('add').disabled) {
    funnel.ready = true;
    track('pap_builder_ready', { name_length: state.name.length,
                                 finish_id: state.finish, quantity: qty });
  }
}
$('nm').addEventListener('input', e => {
  const c = clean(e.target.value);
  if (c !== e.target.value) e.target.value = c;
  state.name = c; build(); renderPrice();
  setDealUnit(totalOf()); renderDeals(); renderUpsell();
  syncURL();
  funnelStep();
});
$('zones').addEventListener('click', e => {
  const b = e.target.closest('[data-z]'); if (!b) return;
  zone = b.dataset.z; renderZones(); renderSwatches();
});
$('swatches').addEventListener('click', e => {
  const b = e.target.closest('[data-h]'); if (!b) return;
  state[zone] = b.dataset.h; paint(); renderZones(); renderSwatches(); renderWarn(); syncURL();
  track('pap_color_changed', { zone });
  funnelStep();
});
$('presets').addEventListener('click', e => {
  const b = e.target.closest('[data-p]'); if (!b) return;
  const {n, sold, ...colours} = PRESETS[b.dataset.p];   // only the zones travel into the design
  Object.assign(state, colours);
  paint(); renderAll();
  track('pap_palette_selected', { palette_id: n });   // a merchant palette name, never a customer one
  funnelStep();
});
if ($('charms')) $('charms').addEventListener('click', e => {
  const b = e.target.closest('[data-c]'); if (!b) return;
  if (b.dataset.c) state.charm = b.dataset.c; else delete state.charm;
  build(); renderAll();
  funnelStep();
});
// Click any part of the print to select that zone — removes a whole layer of UI.
svg.addEventListener('click', e => {
  if (e.target.closest('[data-cord]') && $('charmRow') && !$('charmRow').hidden) {
    $('charmRow').scrollIntoView({block:'nearest', behavior:'smooth'}); return;
  }
  const el = e.target.closest('[data-paint]'); if (!el) return;
  zone = el.dataset.paint; renderZones(); renderSwatches();
  $('swatches').scrollIntoView({block:'nearest', behavior:'smooth'});
});
const seg = (a, b, set) => {
  const flip = on => { a.setAttribute('aria-pressed', on); b.setAttribute('aria-pressed', !on); };
  a.onclick = () => { flip(true);  set(true);  build(); syncURL(); };
  b.onclick = () => { flip(false); set(false); build(); syncURL(); };
};
seg($('fRaise'), $('fEngr'), on => {
  state.finish = on ? 'Raised' : 'Engraved';
  track('pap_finish_changed', { finish_id: state.finish });
  funnelStep();
});

/* Flat/Hanging read as a product choice — customers asked which one they were
   buying. It is only ever a camera angle, so it is now plainly a camera button. */
if ($('rotate')) $('rotate').onclick = e => {
  view = view === 'flat' ? 'hang' : 'flat';
  e.currentTarget.setAttribute('aria-pressed', view === 'hang');
  build();
};

/* Surprise me: a few quick random repaints, then the one that stays. The
   stage's fill transition does the melting; the die on the button spins for
   as long as the roll runs. Reduced motion lands straight away. */
if ($('surprise')) $('surprise').onclick = () => {
  const b = $('surprise');
  if (b.classList.contains('rolling')) return;
  const final = surpriseCombo(state);
  if (!final) return;
  const land = () => {
    Object.assign(state, final); paint(); renderAll();
    b.classList.remove('rolling');
    toast(`Lucky roll ✨ ${nameOf(final.letter, CONFIG.filaments).toLowerCase()} on ` +
          `${nameOf(final.cap, CONFIG.filaments).toLowerCase()}, ${nameOf(final.base, CONFIG.filaments).toLowerCase()} base`);
    track('pap_palette_selected', { palette_id: 'surprise' });
    funnelStep();
  };
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return land();
  b.classList.add('rolling');
  let n = 0;
  const tick = () => {
    if (++n > 5) return land();
    const c = surpriseCombo(state);
    if (c) { Object.assign(state, c); paint(); }
    setTimeout(tick, 80 + n * 30);            // slows as it settles, like a real die
  };
  tick();
};

/* One finish on offer means the chooser is just a decision nobody can make. */
function applyFinishes(){
  const list = finishes();
  if (list.length > 1) return;
  if ($('finishRow')) $('finishRow').hidden = true;
  state.finish = list[0] || 'Raised';
}

$('share').onclick = () => {
  track('pap_share_clicked', {});
  navigator.clipboard.writeText(shareURL({...state, q:qty}))
    .then(() => toast('Link copied — send it to whoever needs to see it'))
    .catch(() => toast('Copy the address bar to share this design'));
};

const setQty = v => {
  const before = qty;
  qty = Math.max(1, Math.min(99, v||1)); $('qty').value = qty; syncURL();
  // Only a real change is an event — retyping the same quantity is not.
  if (qty !== before) { track('pap_quantity_changed', { quantity: qty }); funnelStep(); }
};
$('qMinus').onclick = () => setQty(qty-1);
$('qPlus').onclick  = () => setQty(qty+1);
$('qty').oninput    = e => setQty(parseInt(e.target.value.replace(/\D/g,''),10));

/* The presets strip scrolls sideways on a phone. Show a fade on whichever side
   has more, and a "swipe" nudge only while there is somewhere to swipe TO —
   so neither cue ever points at nothing. On desktop the row wraps, scrollWidth
   equals clientWidth, and both stay hidden on their own. */
function updatePresetHint(){
  const p = $('presets'); if (!p) return;
  const wrap = p.parentElement, hint = $('presetHint');
  const room = p.scrollWidth - p.clientWidth;
  const more = room - p.scrollLeft > 4;
  const scrolled = p.scrollLeft > 4;
  if (wrap && wrap.classList.contains('presetwrap')) {
    wrap.classList.toggle('more', more);
    wrap.classList.toggle('less', scrolled);
  }
  if (hint) hint.hidden = !more || scrolled;   // stop nudging once they have swiped
}
if ($('presets')) $('presets').addEventListener('scroll', updatePresetHint, { passive: true });
addEventListener('resize', updatePresetHint);

/* Arriving from a cart line's Edit link puts us in update mode. */
let editing = new URLSearchParams(location.search).get('edit') || null;
if (editing && !cart.some(x => x.uid === editing)) editing = null;   // line already gone
function applyEditMode(){
  $('add').textContent = editing ? 'Update design' : 'Add to cart';
}

$('add').onclick = () => {
  const design = {...state};
  const item = { kind:'name', qty, design, price:priceOf(), caps:nCaps() };   // the cord is priced live from design.charm
  // Charm cords are finite. Refuse here, in words, rather than let Shopify
  // bounce the whole basket at checkout.
  if (design.charm) {
    const room = charmRoom(charmStock(), charmInCart(editing));
    if (qty > room) {
      toast(room === 0 ? 'No special charms left right now — try the classic cord'
                       : 'Not enough special charms left for that many');
      return;
    }
  }
  funnelStep();   // a shared-link buyer who touched nothing still funnels in order
  track('pap_builder_add_attempt', { name_length: state.name.length,
                                 finish_id: state.finish, quantity: qty });

  // Updating a line we came here to edit.
  if (editing) {
    const at = cart.findIndex(x => x.uid === editing);
    if (at > -1) {
      cart[at] = { ...item, uid: editing };
      editing = null; applyEditMode(); syncURL();
      save(); renderCart(); openCart(true);
      toast('Design updated');
      return;
    }
    editing = null; applyEditMode();
  }

  // The same design again is one more of that line, not a second line.
  const same = cart.findIndex(x => x.kind === 'name' && sameDesign(x.design, design));
  if (same > -1) {
    cart[same].qty = Math.min(99, cart[same].qty + qty);
    toast('Added another of the same design');
  }
  // The static demo checks out through a cart permalink, which carries
  // CART-level attributes only — a second design there would overwrite the
  // first. The theme uses per-line properties and has no such limit.
  else if (!PAP && cart.some(x => x.kind === 'name')) {
    const at = cart.findIndex(x => x.kind === 'name');
    cart[at] = { ...item, uid: cart[at].uid };
    toast('The demo build holds one design at a time, so this replaced it');
  }
  else {
    cart.push({ ...item, uid: newUid() });
    toast('Added to your cart');
  }
  save(); renderCart(); openCart(true);
  offerAnother();
};

/* A second keychain is almost never "quantity 2" — it is a different name for a
   different person. So after adding, offer a fresh design rather than a stepper. */
function offerAnother(){
  const next = nextTier(keychainCount());
  if (!next) { $('another').hidden = true; return; }
  $('another').hidden = false;
  $('another').innerHTML = `Make one for someone else &rarr;`;
}
$('another').onclick = () => {
  track('pap_make_another_clicked', {});   // multi-Pal / gifting intent
  editing = null; applyEditMode();
  $('nm').value = ''; state.name = '';
  build(); renderPrice(); syncURL();
  openCart(false);
  $('another').hidden = true;
  $('nm').focus();
  $('nm').scrollIntoView({ block:'center', behavior:'smooth' });
  toast('Fresh keycaps — type another name');
};

/* ══════════════ boot ══════════════ */
/* How this builder page was reached, as an enum — never a URL. Read BEFORE the
   first render: renderAll() → syncURL() rewrites the query string, so the
   arrival URL only exists here. Homepage links carry controlled ?src= markers
   (hero, product, nav — see index.html and pap-header.liquid); a design in the
   query string is a shared link; the cart drawer's Edit re-entry and unknown
   markers are 'other'. The marker dies with the first syncURL(), so it never
   rides a share link, and the shared-design query itself is read only by
   loadURL to restore the design — it is never sent anywhere. */
const ENTRY_SOURCE = (() => {
  /* Classified once per tab session, then reused: syncURL() rewrites the URL
     with the design, so a REFRESH would otherwise re-read the page's own
     rewrite as an inbound shared link. A pasted design URL in a fresh tab has
     no stored entry and still reads shared_design — which it genuinely is. */
  try { const s = sessionStorage.getItem('pap_entry'); if (s) return s; } catch (_) {}
  const classify = () => {
  const p = new URLSearchParams(location.search);
  const src = p.get('src');
  if (src === 'hero') return 'home_hero';
  if (src === 'product') return 'home_product';
  if (src === 'loved') return 'home_loved';
  if (src || p.get('edit')) return 'other';
  /* shared_design means "a payload the parser below will actually LOAD" — the
     same DESIGN_KEYS and the same truthiness loadURL() uses, so this can never
     claim a shared design the customer did not see. Audited 2026-08-26: the
     production contract is query-string links only (shareURL emits them, the
     order-confirmation _link reuses shareURL, loadURL reads location.search;
     the hash is preserved for nav anchors, never parsed). A V4.2-style
     fragment payload (#v=2&name=...) is deliberately NOT classified shared —
     this parser does not load it, so the customer sees the default design.
     When the fragment contract ships in production, extend BOTH loadURL and
     this check together. The payload itself is read only to restore the
     design; it never reaches analytics in any form. */
  if (DESIGN_KEYS.some(k => p.get(k))) return 'shared_design';
  return 'direct';
  };
  const t = classify();
  try { sessionStorage.setItem('pap_entry', t); } catch (_) {}
  return t;
})();
loadURL();
applyFinishes();

/* A shared link, or a default, can name a colour we have since run out of.
   Snap it to something printable rather than taking an order we can't fill. */
const swapped = PZONES.filter(z => {
  if (hexUsable(state[z])) return false;
  const alt = firstInStock();
  if (alt) { state[z] = alt.h; return true; }
  return false;
});
$('nm').value = state.name; $('qty').value = qty;
$('nm').maxLength = CONFIG.maxCaps;
$('fRaise').setAttribute('aria-pressed', state.finish === 'Raised');
$('fEngr').setAttribute('aria-pressed', state.finish !== 'Raised');
renderPresets(); build(); renderAll(); applyEditMode(); renderDeals(); renderUpsell();
track('pap_builder_view', { name_length: state.name.length,
                            entry_source: ENTRY_SOURCE, traffic_source: TRAFFIC_SOURCE });
if (swapped.length) toast(`Some colours were out of stock, so we picked the nearest we have.`);

/* ══════════════ self-check: open build.html?test ══════════════ */
if (isTest) {
  const ok = (c,m) => { if (!c) throw new Error('FAIL: '+m); console.log('✓', m); };
  ok(shade('#FFFFFF',-1) === '#000000', 'shade(-1) → black');
  ok(shade('#000000', 1) === '#ffffff', 'shade(+1) → white');
  ok(shade('#3FB3C6', 0) === '#3fb3c6', 'shade(0) is identity');
  ok(Math.round(contrast('#FFFFFF','#000000')) === 21, 'white/black ratio is 21');
  ok(contrast('#FFFFFF','#FFFFFF') === 1, 'identical colours ratio 1');
  ok(contrast('#F1645A','#4CA64C') < CONFIG.contrastMin, 'Coral on Green trips the contrast guard');
  ok(contrast('#DA2080','#B3DCD6') > CONFIG.contrastMin, 'the Zayed combo is NOT flagged');
  ok(CONFIG.presets.every(p => contrast(hexOf(p.letter), hexOf(p.cap)) >= 1.8),
     'every preset is comfortably readable, not merely above the floor');
  ok(PAP ? priceOf() === PAP.keychain[nCaps()].p
         : priceOf() === (CONFIG.basePrice + CONFIG.perCap * nCaps()) * 100,
     PAP ? 'price comes from Shopify' : 'price = (base + per-cap × caps) in minor units');
  ok(clean('za yed!! 1234567890').length <= CONFIG.maxCaps, 'name clamps to maxCaps');
  {
    // Finish arrives from the query string. It used to reach the preview title
    // and the cart drawer exactly as written, which made ?finish= a script
    // injection on page load. It is an enum now, and it is escaped on the way
    // out as well, so neither half alone is load-bearing.
    const PAYLOAD = '<img src=x onerror="window.__papXss=1">';
    ok(finishes().includes(cleanFinish(PAYLOAD)), 'a crafted finish becomes one we offer');
    ok(cleanFinish('') === finishes()[0] && cleanFinish(null) === finishes()[0],
       'a missing finish falls back to the default');
    ok(cleanFinish('raised') === 'Raised', 'a legacy lower-case finish still resolves');
    ok(finishes().every(f => cleanFinish(f) === f), 'every offered finish survives unchanged');
    ok(esc(PAYLOAD).indexOf('<') === -1, 'esc() defuses the payload if one ever reaches output');
    {
      // Both sinks, checked against the DOM rather than the source.
      const before = state.finish;
      state.finish = PAYLOAD; build();
      ok(!svg.querySelector('img') && svg.querySelector('title').textContent.indexOf('<img') === -1,
         'the preview title cannot be made to carry markup');
      const saved = cart;
      cart = [{kind:'name', qty:1, caps:5, price:0, uid:'t', design:{...state, finish:PAYLOAD}}];
      renderCart();
      ok(!$('dbd').querySelector('img'), 'the cart drawer cannot be made to carry markup');
      ok(!window.__papXss, 'nothing executed');
      cart = saved; renderCart();
      state.finish = before; build();
    }
  }
  ok(CONFIG.shelf.every(p => p.href || p.ask || DOODLE[p.id]), 'every sellable product has art');
  {
    const base = {id:'x', n:'X', sub:'', price:4500, variant:1, img:null};
    const drop = shelfCard({...base, ld:true, av:true, q:6});
    ok(drop.includes('Limited drop') && drop.includes('only 6 left') && !drop.includes('>Only 6 left<'),
       'a limited drop wears one badge carrying the count, not two chips');
    const gone = shelfCard({...base, ld:true, av:false, q:0});
    ok(gone.includes('Limited drop') && gone.includes('Sold out — more printing soon') && gone.includes('disabled'),
       'a sold-out limited drop keeps its badge and says more are printing');
    ok(!shelfCard({...base, av:true, q:null}).includes('stockchip'), 'an untagged, untracked product wears no chip');
  }
  {
    // The cord is ours to choose. It must not appear as a zone, must not ride
    // in the design, and must not reach the order as a customer selection.
    ok(!ZONES.some(z => z.k === 'cord') && !PZONES.includes('cord'),
       'cord is not a colour zone');
    ok(!('cord' in state) && !DESIGN_KEYS.includes('cord'),
       'cord is not part of the design, so it cannot ride in the URL or _build');
    {
      const props = designProps(state);
      ok(props.Cord === 'Chosen by Print A Pal to match' && !('cord' in JSON.parse(props._build)),
         'the order carries our promise, not a customer cord choice');
    }
    ok(svg.querySelectorAll('[data-paint=cord]').length === 0,
       'nothing in the preview repaints the cord');
    // The special charm cord is the one cord upgrade we sell: absent by default,
    // priced per keychain on top of the variant, a promise on the order (WHICH
    // charms stays ours, like the colour), and shareable.
    {
      const before = {...state};
      ok(!('charm' in state) && !('charm' in JSON.parse(designProps(state)._build)),
         'no charm by default, and the classic cord leaves nothing in _build');
      ok(cleanCharm('hearts') === undefined && cleanCharm('') === undefined,
         'a charm style is not a thing we sell — it is dropped, never carried');
      const beforeBox = svg.getAttribute('viewBox');
      state.charm = CHARM.id; build(); renderPrice();
      ok(svg.querySelectorAll('[data-cord]').length === 1, 'the cord is tappable exactly once');
      ok(svg.querySelectorAll('[data-charm]').length === 1 && !svg.querySelector('[data-charm] [data-paint]'),
         'the clip set is drawn once, in its own fixed colours — never repainted from the design');
      ok(svg.getAttribute('viewBox') === beforeBox, 'the keychain does not shrink to make room for the clip set');
      ok(svg.querySelectorAll('[data-charm] .bell').length === 1, 'the bell is its own group, so it can swing');
      ok(totalOf() === priceOf() + charmPrice() && charmPrice() > 0,
         'the charm cord adds its own price on top of the keychain');
      ok(!PAP ? charmPrice() === CONFIG.charmPrice * 100 : true,
         'the static fallback is the configured price in minor units');
      const props = designProps(state);
      ok(/^Special charm cord/.test(props.Cord) && /chosen by Print A Pal/.test(props.Cord)
         && JSON.parse(props._build).charm === CHARM.id,
         'the order carries our promise — no charm style — and the print spec carries the cord');
      ok(new URL(shareURL({...state, q:1})).searchParams.get('charm') === CHARM.id,
         'a share link carries the charm cord');
      ok(!sameDesign(state, before), 'the same name with a charm cord is a different line');
      const li = { kind:'name', qty:2, design:{...state}, price:priceOf(), caps:nCaps() };
      ok(lineUnit(li) === priceOf() + charmPrice(), 'a cart line is priced with its cord');
      // finite stock: the arithmetic the add button and the drawer share
      ok(charmRoom(null, 99) === Infinity, 'untracked stock never caps');
      ok(charmRoom(3, 0) === 3 && charmRoom(3, 2) === 1 && charmRoom(3, 5) === 0,
         'room is what is left after the basket, never negative');
      {
        const saved = cart;
        cart = [{kind:'name', qty:2, caps:5, price:0, uid:'a', design:{...state}},
                {kind:'name', qty:1, caps:5, price:0, uid:'b', design:{...state, charm: undefined}},
                {kind:'name', qty:3, caps:5, price:0, uid:'c', design:{...state}}];
        ok(charmInCart() === 5 && charmInCart('c') === 2,
           'only charm-cord keychains count, and the line being edited is left out');
        cart = saved;
      }
      ok(charmStock() === null, 'the static build has no stock to ask about');
      delete state.charm; build(); renderPrice();
      ok(JSON.stringify(state) === JSON.stringify(before), 'back to the classic cord leaves the design untouched');
      renderAll();
    }
    ok(CONFIG.presets.every(p => PZONES.every(k =>
         CONFIG.filaments.some(c => c.n === p[k]))),
       'every preset names filament colours that exist');
    // The row is the best-seller chart, so it must read like one: every entry
    // carries its order count and the counts run downhill.
    ok(CONFIG.presets.every((p, i, a) => p.sold > 0 && (!i || a[i - 1].sold >= p.sold)),
       'presets are ranked by real orders, most ordered first');
    // Both shapes still appear: a base that matches the keycaps and one that
    // frames them. All of one kind and the row stops teaching anything.
    {
      const three = CONFIG.presets.filter(p => p.base !== p.cap).length;
      ok(three >= 1 && CONFIG.presets.length - three >= 1,
         `presets mix two- and three-colour combos (${CONFIG.presets.length - three} + ${three})`);
    }
    {
      ok(!/orders|data-rank/.test($('presets').innerHTML), 'order counts and ranks stay backstage');
      const before = { ...state };
      const pressed = () => [...$('presets').querySelectorAll('[aria-pressed=true]')].map(b => b.title);
      $('presets').querySelector('[data-p="0"]').click();
      ok(!('sold' in state) && !('n' in state) && state.cap === PRESETS[0].cap,
         'picking a best seller paints its colours and nothing else into the design');
      ok(pressed().join() === PRESETS[0].n, 'the pill on screen is the one lit up');
      state.letter = '#2E2E33'; renderAll();
      ok(pressed().length === 0, 'a hand-mixed colour lights no pill');
      // the die: every roll is printable, in stock, and never the combo on screen
      for (let i = 0; i < 100; i++) {
        const c = surpriseCombo(state);
        ok(c && PZONES.every(k => hexUsable(c[k])) && contrast(c.letter, c.cap) >= 1.8
           && !(c.letter === state.letter && c.cap === state.cap && c.base === state.base),
           i ? 'and again' : 'surprise me rolls a printable, in-stock combo that is not the current one');
        if (i) break;   // one pass proves the shape; the loop above hunts for a bad roll
      }
      Object.assign(state, before); delete state.sold; paint(); renderAll();
    }
    // palette-agnostic: whatever the first preset names, it must resolve to that
    // colour's current hex, so re-mixing a colour follows through
    {
      const p0 = CONFIG.presets[0], r0 = resolvePreset(p0);
      ok(r0 && r0.cap === hexOf(p0.cap) && r0.letter === hexOf(p0.letter),
         'presets resolve by name, so re-mixing a colour follows through');
    }
    ok(parsePalette('Orange #FF6A13\nYellow #f2c14e')?.length === 2, 'palette parses Name #HEX lines');
    ok(parsePalette('Orange #F60')[0].h === '#FF6600', 'palette expands 3-digit hex');
    ok(parsePalette('nonsense\n\n#123456') === null, 'a palette of only bad lines falls back');
    ok(parsePalette('Orange #FF6A13\nOrange #000000').length === 1, 'duplicate names are dropped');
    // Only true without a store: with PAP, anything Shopify does not sell is
    // dropped on purpose. (Ran green until theme-preview.html?test was tried.)
    ok(PAP || CONFIG.shelf.every(isOffered),
       'static build offers everything — it has no store to ask');
  }
  ok(CONFIG.shelf.every(p => p.href || p.ask || typeof p.p === 'number'), 'every addable product has a fallback price');
  {
    // Tabby is not a Shopify payment type, so it is added by hand — fourth,
    // after Visa, in both the theme row and the static fallback.
    const html = paymentsHTML();
    const at = s => html.indexOf(s);
    ok(at('Tabby') > -1 && at('Visa') < at('Tabby') && at('Google Pay') < at('Visa') && at('Apple Pay') < at('Google Pay'),
       'payments read Apple Pay, Google Pay, Visa, Tabby, then the rest');
    ok(/tabby\.svg/.test(html), 'the Tabby badge is our own SVG');
  }
  {
    // A basket outlives the stock list. A saved design naming a colour that has
    // since run out must be flagged in the drawer and must not reach checkout.
    const savedCart = cart, savedOOS = OOS;
    const lav = hexOf('Lavender');
    cart = [{kind:'name', qty:1, caps:4, price:4800, uid:'stale', design:{...state, base: lav}}];
    OOS = { filament: new Set(['lavender']) };
    renderCart();
    ok(lineStale(cart[0]) && staleNames(cart[0].design) === 'Lavender', 'a saved design with a retired colour is stale');
    ok($('dbd').querySelector('.stale') && $('dbd').textContent.includes('Lavender is out of stock'),
       'the drawer says which colour ran out and points at Edit');
    ok($('checkout').disabled, 'checkout is blocked while a stale line is in the basket');
    OOS = { filament: new Set() };
    renderCart();
    ok(!lineStale(cart[0]) && !$('checkout').disabled, 'back in stock, the same line checks out again');
    OOS = savedOOS; cart = savedCart; renderCart();
  }
  ok(money(4000) === 'AED 40', 'money() formats whole amounts');
  ok(money(4050) === 'AED 40.50', 'money() formats fractional amounts');
  // Static-only: with a store the price comes from Shopify and checkout is the
  // AJAX cart, so the permalink is never built.
  if (!PAP) {
    ok(keychainPrice(5) === 4000, 'static keychain price is in minor units');
    const saved = cart; cart = [{kind:'name', qty:2, caps:5, price:40, design:{...state}}];
    const u = checkoutURL();
    ok(u.includes('/cart/null:2'), 'permalink carries variant:qty');
    ok(decodeURIComponent(u).includes('attributes[_build]'), 'permalink carries _build for the print queue');
    ok(!JSON.parse(decodeURIComponent(u).match(/_build\]=({.*?})&/)[1]).view, 'view stays out of _build');
    ok(u.startsWith('https://'+CONFIG.shop), 'permalink points at the configured shop');
    cart = saved;
  }
  // Rotate is a view control: it must turn the preview and touch nothing else.
  {
    const before = {...state}, r = $('rotate');
    r.click();
    ok(view === 'hang' && r.getAttribute('aria-pressed') === 'true', 'rotate turns the preview');
    ok(svg.getAttribute('viewBox').split(' ')[2] < svg.getAttribute('viewBox').split(' ')[3],
       'hanging is taller than it is wide');
    r.click();
    ok(view === 'flat' && r.getAttribute('aria-pressed') === 'false', 'rotate turns it back');
    ok(JSON.stringify(state) === JSON.stringify(before), 'rotating changes nothing about the print');
  }
  // Analytics: allowlisted, deduped, and never carrying a customer name.
  {
    const seen = [];
    setSink((e, p) => seen.push({e, p}));
    track('pap_builder_add_attempt', { name_length: 5, secret: 'ZAYED' });
    ok(seen.length === 1 && seen[0].e === 'pap_builder_add_attempt', 'events reach the sink');
    ok(seen[0].p.name_length === 5 && !('secret' in seen[0].p),
       'only allowlisted properties travel — a customer name never does');
    track('not_a_real_event', {});
    ok(seen.length === 1, 'an undeclared event name is dropped');
    const saved = { ...funnel };
    funnel.started = funnel.ready = false;
    seen.length = 0;
    funnelStep(); funnelStep(); funnelStep();
    Object.assign(funnel, saved);
    setSink(null);
    ok(seen.filter(x => x.e === 'pap_builder_start').length === 1,
       'pap_builder_start fires exactly once however many interactions follow');
    ok(seen.filter(x => x.e === 'pap_builder_ready').length <= 1,
       'and pap_builder_ready never repeats');
    ok(!JSON.stringify(seen).includes(state.name || '@'),
       'and no funnel event carries the typed name');
  }
  // segmentation: buckets, never the raw material they came from
  {
    ok(['mobile', 'tablet', 'desktop'].includes(DEVICE_CLASS),
       `device_class is a layout bucket (${DEVICE_CLASS})`);
    ok(['meta_paid', 'meta_other', 'instagram_organic', 'google_paid', 'google_organic',
        'direct', 'other'].includes(TRAFFIC_SOURCE),
       `traffic_source is an acquisition bucket (${TRAFFIC_SOURCE})`);
    ok(ENTRY_SOURCE === 'direct', 'a bare ?test load reads as a direct entry');
    const seen = [];
    setSink((e, p) => seen.push({ e, p }));
    const savedName = state.name, savedEditing = editing;
    $('another').click();
    setSink(null);
    ok(seen.some(x => x.e === 'pap_make_another_clicked'),
       'Make one for someone else is tracked');
    ok(seen.every(x => x.p.device_class === DEVICE_CLASS),
       'and every event carries the device bucket');
    ok(!JSON.stringify(seen).match(/user.?agent|referrer|utm|fbclid|gclid|https?:/i),
       'and nothing raw rode along');
    editing = savedEditing; state.name = savedName; $('nm').value = savedName;
    build(); renderPrice(); syncURL(); applyEditMode();
  }
  // shelf intent: an ELIGIBLE Add is the event — a sold-out tap is not an attempt
  {
    const seen = [];
    setSink((e, p) => seen.push({ e, p }));
    const savedCart = cart.slice();
    const tmp = document.createElement('div');
    renderShelf(tmp); document.body.append(tmp);
    const btn = tmp.querySelector('[data-add]');
    if (btn) {
      btn.click();
      const shelfEvents = () => seen.filter(x => x.e === 'pap_shelf_add_attempt');
      ok(shelfEvents().length === 1, 'an available Add tap is tracked exactly once');
      ok(Object.keys(shelfEvents()[0].p).join() === 'device_class',
         'and carries the device bucket, nothing else — no product text, no price');
      // the same product, sold out: the guard refuses the add, so no attempt fires
      const p = SHELF.find(s => s.id === btn.dataset.add)
             || CONFIG.shelf.find(s => s.id === btn.dataset.add);
      const savedAv = p.av;
      p.av = false;
      btn.click();
      p.av = savedAv;
      ok(shelfEvents().length === 1,
         'a sold-out tap fires nothing — attempts stay comparable to real cart adds');
    }
    setSink(null);
    tmp.remove();
    cart.length = 0; cart.push(...savedCart); save(); renderCart(); openCart(false);
  }
  // shared-link classification matches what the parser actually loads: the
  // classifier reads location.search, and a fragment payload never enters it
  {
    const u = new URL('https://example.test/build.html#v=2&name=SARA&letter=magenta');
    const p = new URLSearchParams(u.search);
    ok(!DESIGN_KEYS.some(k => p.get(k)),
       'a fragment-only design link carries no query payload — it reads direct, not shared');
    const q = new URLSearchParams(new URL('https://example.test/build.html?name=SARA&letter=%23DA2080&cap=%23B3DCD6&base=%23B3DCD6&finish=Raised&q=1').search);
    ok(DESIGN_KEYS.some(k => q.get(k)),
       'while a real shareURL()-format link is recognised as a shared design');
  }
  console.log('%c all checks passed ', 'background:#4CA64C;color:#fff;border-radius:4px');
}
